import { render, staticRenderFns } from "./pay-result-alert.vue?vue&type=template&id=db6405be&scoped=true"
import script from "./pay-result-alert.vue?vue&type=script&lang=js"
export * from "./pay-result-alert.vue?vue&type=script&lang=js"
import style0 from "./pay-result-alert.vue?vue&type=style&index=0&id=db6405be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db6405be",
  null
  
)

export default component.exports